"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionEditViewSubform = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var image_button_1 = require("../../components/button/image.button");
var icon_1 = require("../../components/icon");
var icons_1 = require("../../components/icon/icons");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var classnames_1 = require("../../util/classnames");
var collection_view_field_1 = require("./collection.view.field");
var collection_view_style_1 = require("./collection.view.style");
var subform_duplicate_tool_1 = require("./subform.tool/subform.duplicate.tool");
var subform_remove_tool_1 = require("./subform.tool/subform.remove.tool");
var CollectionEditViewSubform = /** @class */ (function () {
    function CollectionEditViewSubform() {
    }
    CollectionEditViewSubform.view = function (ctrl, collection) {
        var realFields = [];
        var subForms = [];
        for (var _i = 0, _a = collection.schema.fields; _i < _a.length; _i++) {
            var field = _a[_i];
            if (core_shared_1.FormModelFieldSubForm.isSubForm(field)) {
                subForms.push(CollectionEditViewSubform.viewSubform(ctrl, collection, field));
            }
            else {
                realFields.push(collection_view_field_1.CollectionEditViewField.view(ctrl, collection, field));
            }
        }
        var className = "".concat(collection_view_style_1.CSS.form.container, " ").concat(collection_view_style_1.CSS.form.isRoot);
        var id = "i-".concat(collection.instanceId);
        var style = { display: (ctrl.kind === 'TopologicalEditorCollectionEditCtrl' && ctrl.isCarouselShown === true) ? 'none' : 'block' };
        return (0, mithril_1.m)('div', { className: className, id: id, style: style }, realFields.concat(subForms));
    };
    CollectionEditViewSubform.viewSubform = function (ctrl, collection, schema) {
        var id = "i-".concat(collection.instanceId, "-").concat(schema.id);
        var field = collection.getField(schema.id);
        var instances = field.value || [];
        var isEmpty = instances.length === 0 ? collection_view_style_1.CSS.isEmpty : '';
        var showFooter = false;
        var children = [];
        for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
            var instance = instances_1[_i];
            children.push(CollectionEditViewSubform.viewInstance(ctrl, instance));
            showFooter = showFooter || ctrl.isExpanded(instance.instanceId);
        }
        var title = schema.displayName;
        var userIsAdmin = services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)) || services_1.Services.UserProfile.isDepartmentDataAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId));
        var userCanEditField = userIsAdmin || !field.schema.adminOnly;
        return (0, mithril_1.m)('div', {
            className: (0, classnames_1.classNames)(collection_view_style_1.CSS.form.container, isEmpty),
            id: id
        }, tslib_1.__spreadArray(tslib_1.__spreadArray([
            (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.header }, [
                (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.title }, [
                    (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.titleName, title: title }, title),
                    instances.length > 0 ? (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.titleCount }, String(instances.length)) : null
                ]),
                (ctrl.isEditing && userCanEditField) ? CollectionEditViewSubform.viewEditTools(ctrl, collection, schema) : null
            ])
        ], children, true), [
            (ctrl.isEditing && showFooter && userCanEditField) ? CollectionEditViewSubform.viewFooter(ctrl, collection, schema) : null
        ], false));
    };
    CollectionEditViewSubform.viewInstance = function (ctrl, collection) {
        var _a;
        var id = "i-".concat(collection.instanceId);
        var instanceTitle = collection.title;
        var formTitle = collection.formTitle;
        var title = formTitle;
        if (instanceTitle != null && instanceTitle !== formTitle) {
            title = "".concat(formTitle, " \u2014 ").concat(instanceTitle);
        }
        var isExpanded = ctrl.isExpanded(collection.instanceId);
        var spanColor = ctrl.useColorCoding ? core_shared_1.FormModelFieldSubForm.getSpanColor(collection) : 'none';
        return (0, mithril_1.m)('div', {
            id: id,
            className: (0, classnames_1.classNames)(collection_view_style_1.CSS.instance.container, (_a = {},
                _a[collection_view_style_1.CSS.instance.isOpen] = isExpanded,
                _a))
        }, [
            (0, mithril_1.m)('div', {
                title: title,
                onclick: function (e) { return ctrl.toggleExpanded(e, collection.instanceId); }, className: collection_view_style_1.CSS.instance.header,
                style: { 'border-left': "6px solid ".concat(spanColor) }
            }, [
                (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.instance.text }, title),
                CollectionEditViewSubform.viewInstanceEditTools(ctrl, collection)
            ]),
            isExpanded ? CollectionEditViewSubform.view(ctrl, collection) : null
        ]);
    };
    CollectionEditViewSubform.viewEditTools = function (ctrl, collection, schema) {
        var field = collection.getField(schema.id);
        var title = schema.displayName;
        var tools = [];
        if (services_1.Services.SubFormLink.isSubFormCompatible(schema)) {
            tools.push(image_button_1.ImageButton.view(icons_1.MaterialIcon.SPAN_LINK, {
                title: i18n_1.T.SPAN_LINK_TITLE,
                onclick: function () { return ctrl.beginSpanLink(collection); }
            }));
        }
        tools.push(image_button_1.ImageButton.view(icons_1.MaterialIcon.ADD, {
            title: i18n_1.T.COLLECTION_EDIT_CREATE_SUBFORM,
            titleAttrs: { title: title },
            onclick: function () { return field.Mutator.create(); }
        }));
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.tools }, tools);
    };
    CollectionEditViewSubform.viewFooter = function (ctrl, collection, schema) {
        var field = collection.getField(schema.id);
        var buttons = [
            (0, mithril_1.m)('button', { className: collection_view_style_1.CSS.form.footerButton + ' mdl-button', onclick: function () { return field.Mutator.create(); } }, [
                icon_1.Icon.view(icons_1.MaterialIcon.ADD),
                (0, mithril_1.m)('span', "Add new ".concat(schema.displayName))
            ])
        ];
        if (services_1.Services.SubFormLink.isSubFormCompatible(schema)) {
            buttons.push((0, mithril_1.m)('button', { className: collection_view_style_1.CSS.form.footerButton + ' mdl-button', onclick: function () { return ctrl.beginSpanLink(collection); } }, [
                icon_1.Icon.view(icons_1.MaterialIcon.SPAN_LINK),
                (0, mithril_1.m)('span', (0, i18n_1.Translate)(i18n_1.T.SPAN_LINK_TITLE))
            ]));
        }
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.form.footer }, buttons);
    };
    CollectionEditViewSubform.viewInstanceEditTools = function (ctrl, collection) {
        var userIsAdmin = services_1.Services.UserProfile.isDepartmentAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId)) || services_1.Services.UserProfile.isDepartmentDataAdmin(services_1.Services.UserProfile.get(services_1.Services.User.current.objectId));
        var userCanEditField = userIsAdmin || !collection.schema.adminOnly;
        if (!(ctrl.isEditing && userCanEditField)) {
            return null;
        }
        return (0, mithril_1.m)('div', { className: collection_view_style_1.CSS.instance.tools }, [
            subform_duplicate_tool_1.SubformDuplicateTool.view(collection),
            subform_remove_tool_1.SubformRemoveTool.view(ctrl, collection)
        ]);
    };
    return CollectionEditViewSubform;
}());
exports.CollectionEditViewSubform = CollectionEditViewSubform;
//# sourceMappingURL=collection.view.subform.js.map